import { createFileRoute } from "@tanstack/react-router";
import { Phone, Mail, Clock } from "lucide-react";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { LeadForm } from "@/components/site/LeadForm";

export const Route = createFileRoute("/contactos")({
  component: Contactos,
  head: () => ({
    meta: [
      { title: "Contactos — InvestCapital" },
      { name: "description", content: "Fale com a InvestCapital. Telefone +351 934 371 241 · proposta@investcapital.pt." },
      { property: "og:title", content: "Contactos — InvestCapital" },
      { property: "og:description", content: "Contacte a InvestCapital: +351 934 371 241 ou proposta@investcapital.pt. Respondemos em 24h úteis, todos os dias." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: "https://www.investcapital.pt/og-investcapital.jpg" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:image", content: "https://www.investcapital.pt/og-investcapital.jpg" },
      { property: "og:url", content: "https://www.investcapital.pt/contactos" },
    ],
    links: [{ rel: "canonical", href: "https://www.investcapital.pt/contactos" }],
  }),

});

function Contactos() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>

      <section className="border-b border-border/60 bg-primary-soft/40">
        <div className="mx-auto max-w-6xl px-4 py-16 md:py-20">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary">Contactos</p>
          <h1 className="mt-2 font-display text-4xl font-semibold md:text-5xl">Informe-se connosco.</h1>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
            Gostamos de fazer parte da solução. Envie-nos uma mensagem — respondemos em 24h úteis.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-20">
        <div className="grid gap-10 md:grid-cols-[1fr_1.2fr]">
          <div className="space-y-4">
            {[
              { icon: Phone, label: "Telefone", value: "+351 934 371 241", href: "tel:+351934371241", note: "(Chamada para rede móvel nacional)" },
              { icon: Mail, label: "E-mail", value: "proposta@investcapital.pt", href: "mailto:proposta@investcapital.pt" },
              { icon: Clock, label: "Horário", value: "Seg a Dom — 24h" },
            ].map((c) => (
              <div key={c.label} className="flex items-start gap-4 rounded-2xl border border-border bg-card p-5">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-soft text-primary">
                  <c.icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-muted-foreground">{c.label}</div>
                  {c.href ? (
                    <a href={c.href} className="text-lg font-medium text-foreground hover:text-primary">
                      {c.value}
                    </a>
                  ) : (
                    <div className="text-lg font-medium text-foreground">{c.value}</div>
                  )}
                  {c.note && <div className="mt-1 text-xs text-muted-foreground">{c.note}</div>}
                </div>
              </div>
            ))}
            <div className="rounded-2xl border border-dashed border-border bg-muted/40 p-5 text-sm text-muted-foreground">
              investcapital.pt · Portugal continental
            </div>
          </div>

          <div className="rounded-2xl border border-border bg-card p-6 md:p-8">
            <h2 className="font-display text-2xl font-semibold">Envie a sua mensagem</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              A análise é gratuita e sem qualquer compromisso.
            </p>
            <div className="mt-6">
              <LeadForm />
            </div>
          </div>
        </div>
      </section>

      </main>
      <SiteFooter />
    </div>
  );
}
